<template>
  <div class="mb-2">
    <b-form-group id="fileInput" ref="uploadFile" class="dragdrop custom-dragdrop">
      <b-form-file
        multiple
        :accept="$attrs['accept']"
        :placeholder="placeholder" 
        v-model="additional_files" 
        @input="onInputFiles()"
      />
    </b-form-group>
    <span class="ml-3" style="height: 16px;">( Max upload file size: {{fileSize}}MB,{{ $attrs['accept'] ? ` Type: ${$attrs['accept']}` : '' }})</span>
    <b-col class="custom-file-layout mt-4" v-if="files.length" v-cloak>
      <b-list-group>
        <b-list-group-item 
          class="d-flex justify-content-between p-1 mb-2"
          style="height: 27px; background: #EBEBEB; border-radius: 0%;"
          v-for="(file, idx) in files" 
          :key="idx"
        >
          <span class="text-muted ml-1 mr-3" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ formattedFileName(file.name) }}
          </span>
          
          <button type="button" aria-label="Close" class="close btn2 btn2-tertiary btn2-md" @click="remove(idx, file)">
            <feather
              type="x"
              class="align-self-center icon-xs"
            />
          </button>
        </b-list-group-item>
      </b-list-group>
    </b-col>

    <Loading ref="loading"/>

  </div>
</template>

<script>
import error from '@utils/error'
import Loading from '@components/LoadingSpinner'
export default {
  components: {
    Loading
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    },
    noDelete: {
      type: Boolean,
      default: () => false
    },
    hasViewFile: {
      type: Boolean,
      default: () => false
    },
    placeholder: String,
    fileSize: {
      type: Number,
      default: () => 5
    }
  },
  computed: {
    computedFiles() {
      let parameters = this.parameters || {}
      return parameters.files || []
    },
  },
  data() {
    return {
      files: [],
      additional_files : [], // for multiple upload of resumes in edit mode only
      showUploadModal:false,
      file_count: 0,
      isPreview: false,
      removed: []
    }
  },
  methods: {
    onInputFiles() {
      let files = this.additional_files
      files.forEach((file) => {
        let isValid = this.validateFileSize(file)

        if(isValid)
          this.files.push(file)
      });

      this.additional_files = []
      this.$emit('input', this.files)
    },
    remove(idx, file) {
      this.files.splice(idx, 1)

      if(file._id) {
        this.removed.push(file)
      }
      this.$emit('input', this.files)
      this.$emit('delete', this.removed)
    },
    formattedFileName(name) {
      if(this.hasViewFile)
        return name.replace(/.docx|.pdf|.doc|.xlsx/gi, ".pdf");

      return name
    },
    parseDocuments(attachments){
      let attachmentData = attachments || []
      if(attachmentData.length > 0){
        for(let index = 0; index < attachmentData.length; index++) {
          const element = attachmentData[index];
          // if(element.mimetype === 'application/pdf' && this.hasViewFile) {
            let result = {
              name: element.originalname,
              size: element.size,
              _id: element._id,
              path: element.path,
              isUploaded: true
            }
            this.files.push(result)
          // }
        }
      }
    },
    validateFileSize(file) {
      let validFileSize = this.fileSize * (1024*1024)
      let isNotValid = file['size'] > validFileSize

      if(isNotValid) {
        let message = `File size exceeds ${this.fileSize}mb.`
        return error.errorHandler({ message }, this.$bvToast)
      }

      return !isNotValid
    }
  },
  mounted() {
    this.files = this.computedFiles
  }
}
</script>

<style lang="scss">
.inputWrapper {
  overflow: hidden;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  color: blue;
}

.add-new-file {
  cursor: pointer;
  height: 100%;
  position:absolute;
  top: 0;
  right: 0;
  font-size:50px;
}
.hidden {
  /*Opacity settings for all browsers*/
  opacity: 0;
  -moz-opacity: 0;
  filter:progid:DXImageTransform.Microsoft.Alpha(opacity=0)
}


/*Dynamic styles*/
.inputWrapper:hover {
  background-color: transparent;
}
.inputWrapper.clicked {
  background-color: transparent;
}

.custom-dragdrop {
  margin-bottom: 0 !important;
  
  .custom-file-input,
  .custom-file,
  .custom-file-label {
    padding: 0px !important;
    line-height: 3;
    height: 34.5px !important;
  }   
  
}
.custom-file-layout {
  padding: 0 !important;
}

.file-list-item {
  display: flex;
  padding: 5px 8px 4px 8px;
  justify-content: center;
  align-items: flex-start;
  gap: 335px;
}
</style>